import { render, staticRenderFns } from "./SFormLotComp.vue?vue&type=template&id=215b2cc5&"
import script from "./SFormLotComp.vue?vue&type=script&lang=js&"
export * from "./SFormLotComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports